import { createPortal } from 'react-dom';

import '../../../JxControls/JxTheme.css';

import JxButton from '../../../JxControls/JxButtons/JxButton';
import { jxScrollbarThin } from '../../../JxControls/jxScrollbarStyle';
import JxFilterEdit from '../../../JxControls/JxEdits/JxFilterEdit';
import JxTitleBar from '../../../JxControls/JxTitleBar/JxTitleBar';
import componentNotifier from '../../../services/wss/ComponentNotifier';
import { EngineNames } from '../../../services/wss/events/EngineNames';

import { TITLE_BAR_ACTIONS } from './LoadUmlNoteDlgTitleBarActions';
import umlNotesEngine from '../../Core/UmlNotesEngine';
import { createSchema, createEmpty } from './LoadUmlNoteDlgSchema';

import LoadUmlNoteRow from './LoadUmlNoteRow';
import './LoadUmlNoteDlg.css';
import { JxFormResizableBase } from '@/JxControls/index';

/**
 *
 * opens list op note of type UmlSchema aka the journal
 * note that holds Uml canvas objects
 *
 * @param {{ open: boolean, onClose: Function, onSelect: Function }} props
 */
export default class LoadUmlNoteDlg extends JxFormResizableBase {
    constructor(props) {
        super(props);
        this.name = 'LoadUmlSchemaDlg';
        this.schema = createSchema();
        this.state = { ...this.state, inputs: createEmpty() };
    }

    componentDidMount() {
        super.componentDidMount();
        this.bringToTop();
        this._unsubscribeEngine = componentNotifier.subscribe(EngineNames.UmlNotesEngine, this._handleEngineEvent);
        this._unsubscribePreviewEngine = componentNotifier.subscribe(EngineNames.UmlPreviewEngine, this._handleEngineEvent);
    }

    componentWillUnmount() {
        if (this._unsubscribeEngine) this._unsubscribeEngine = this._unsubscribeEngine();
        if (this._unsubscribePreviewEngine) this._unsubscribePreviewEngine = this._unsubscribePreviewEngine();
        super.componentWillUnmount();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        if (this.props.open && !prevProps.open) {
            this.setState({ inputs: createEmpty() });
        }
    }

    /**
     * NOTE: inline event handler — if this dialog grows more engine-driven state, move to
     * _handlers pattern (Development.Patterns rk=6c294559-b0b6-4dc0-a4cd-08ddfa7be0c7).
     */
    _handleEngineEvent = (e) => {
        if (e.target !== 'dataChanged') return;
        this.forceUpdate();
    };

    getDefaultGeo() {
        return { top: 180, left: 138, width: 389, height: 291 };
    }

    handleClose = async (action) => {
        try {
            this.props.onClose?.();
        } catch (error) {
            this.logError('handleClose', error.message);
        }
    };

    handleSelect = (note) => {
        this.props.onSelect?.(note);
        this.handleClose(0);
    };

    getFilteredItems() {
        const items = umlNotesEngine.getAll();
        const filter = this.state.inputs.name;
        if (!filter) return items;
        const needle = filter.toLowerCase();
        return items.filter(function matchFilter(item) {
            return (item.title || '').toLowerCase().includes(needle);
        });
    }

    render() {
        if (!this.props.open) return null;

        const items = this.getFilteredItems();

        const panel = (
            <div {...this.panelProps} style={this.panelStyle} className={`jx-panel lusd-panel ${this.panelActiveClass}`}>
                <JxTitleBar
                    id={`${this.name}_titlebar`}
                    title="Load Uml Schema"
                    variant="toolwindow"
                    isDraggable={true}
                    dragHandleProps={this.dragHandleProps}
                    actions={TITLE_BAR_ACTIONS(() => this.handleClose(-1))}
                />

                <div className="lusd-filter">
                    <JxFilterEdit
                        id="lusd_filter"
                        value={this.state.inputs.name}
                        onChange={(v) => this.handleChange('name', v)}
                        placeholder="Filter uml schemas..."
                    />
                </div>

                <div className={`lusd-body ${jxScrollbarThin}`}>
                    {items.length === 0 && <div className="lusd-empty">No UmlSchema notes found.</div>}
                    {items.map((item) => (
                        <LoadUmlNoteRow key={item.rk} item={item} isSelected={false} onSelect={this.handleSelect} />
                    ))}
                </div>

                <div className="lusd-footer">
                    <JxButton label="Close" onClick={() => this.handleClose(0)} />
                </div>

                {this.renderResizeHandles()}
            </div>
        );

        return createPortal(panel, document.body);
    }
}
